import React, { PropsWithChildren } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'

const Container = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.M};
  padding: ${rem(20)};
  max-width: ${rem(440)};
  width: 80%;

  ${mediaQueryUp.tablet} {
    width: ${rem(500)};
  }
`

type Props = PropsWithChildren<{}>

export default function LesaPurchaseSummaryContainer(props: Props) {
  const { children } = props

  return (
    <Container direction="vertical" fullWidth>
      {children}
    </Container>
  )
}
